import { Mail } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import {
  FEATURE_PAYSLIP_QUERY,
  FEATURE_ROSTER_QUERY,
  FEATURE_TIMESHEET_QUERY,
  FEATURE_LEAVE_MANAGEMENT,
} from "../../utils/UserAccessControlUtils";
import InboxQueryPage from "./pages/InboxQueryPage";

const InboxQueryRouter: NavigationLinkProps[] = [
  {
    id: "2e56ba97-eb93-4f93-9146-e45a8e4a7606",
    title: "Inbox",
    description: "",
    path: "/query/:uuid?/:tab?",
    auth: true,
    sidebar: true,
    icon: Mail,
    component: InboxQueryPage,
    requiredFeature: [
      FEATURE_PAYSLIP_QUERY,
      FEATURE_ROSTER_QUERY,
      FEATURE_TIMESHEET_QUERY,
      FEATURE_LEAVE_MANAGEMENT,
    ],
    requiredPermissions: ["ANY"],
  },
];

export default InboxQueryRouter;
